// Import model
import { FilterSectionRequest } from '../models/FilterSectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { SectionCondition } from '../models/SectionCondition';
import { SectionFields } from '../models/SectionFields';
import { SectionIndexedFields } from '../models/SectionIndexedFields';

// Import dependency serializers (for complex types)
import { SectionConditionSerializer } from './SectionConditionSerializer';
import { SectionFieldsSerializer } from './SectionFieldsSerializer';
import { SectionIndexedFieldsSerializer } from './SectionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterSectionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterSectionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterSectionRequest instance
   */
  static deserialize(json: string): FilterSectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterSectionRequest instance
   */
  static fromObject(obj: any): FilterSectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterSectionRequest');
    }


    const instance: FilterSectionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as SectionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as SectionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        SectionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterSectionRequest instances
   */
  static deserializeArray(json: string): FilterSectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterSectionRequest instance to a JSON string
   */
  static serialize(instance: FilterSectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterSectionRequest instance to a plain object
   */
  static toObject(instance: FilterSectionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        SectionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterSectionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterSectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
